import React from 'react';
import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import loadingDots from '../../../assets/onboarding/loading-dots.gif';
import { CENTERED_BAND_MAX_HEIGHT } from '../handoffConstants';

const { Title, Text } = Typography;

/**
 * Screen 1 — shown while the launch token is being redeemed and the operation
 * status is polled.
 */
const LoadingScreen = () => {
	const { t } = useTranslation();

	return (
		<div
			style={{
				flex: 1,
				maxHeight: CENTERED_BAND_MAX_HEIGHT,
				minHeight: 'min-content',
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
				textAlign: 'center',
				padding: 24,
				gap: 48
			}}>
			<img
				src={loadingDots}
				alt=""
				// The GIF ships with a solid white background; multiply blends it into
				// the page background so no white box shows.
				style={{
					width: 'min(480px, 80%)',
					height: 'auto',
					objectFit: 'contain',
					mixBlendMode: 'multiply'
				}}
			/>

			<div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
				<Title level={3} style={{ color: '#2F4858', margin: 0, fontWeight: 700 }}>
					{t('handoff.loadingTitle', 'Accediendo a tu portal de hipotecas')}
				</Title>
				<Text style={{ color: '#748EA0' }}>
					{t('handoff.loadingDescription', 'Estamos recuperando tu información de forma segura.')}
				</Text>
				<Text style={{ color: '#748EA0' }}>
					{t('handoff.loadingWait', 'Esto no tardará mucho.')}
				</Text>
			</div>
		</div>
	);
};

export default LoadingScreen;
